import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EmailValidator } from '../login/emailValidator.validator';
import { UserState } from 'src/app/state/user-state';
import { Store } from '@ngrx/store';
import * as UserAuthActions from '../../../state/actions/user-authentification.actions';
import { SpinnerService } from 'src/app/core/services/spinner.service';
import { ICONS } from 'src/app/core/constants/icons';
import { ROUTES } from 'src/app/core/constants/routes';

@Component({
  selector: 'app-recovery',
  templateUrl: './recovery.component.html',
  styleUrls: ['./recovery.component.scss']
})
export class RecoveryComponent implements OnInit {
  recoveryForm = new FormGroup({
    email: new FormControl('')
  });

  submitted = false;
  LOGO = ICONS.LOGO;
  USERNAME = ICONS.NEW_USERNAME;
  LOGIN_ROUTE = ROUTES.LOGIN;
  isEmailInputFocused = false;

  constructor(
    protected spinnerService: SpinnerService,
    private formBuilder: FormBuilder,
    private store: Store<UserState>
  ) {}

  get f() {
    return this.recoveryForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    this.spinnerService.showSpinner();
    if (this.recoveryForm.valid) {
      const email = this.recoveryForm.value.email as string;
      this.store.dispatch(UserAuthActions.USER_ACCOUNT_RECOVERY({ email }));
    }
  }
  ngOnInit() {
    this.store.dispatch(UserAuthActions.RESET_AUTH_ERROR_MESSAGE());
    this.recoveryForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, EmailValidator]]
    });
  }
}
